import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'
import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'

import { findGeofenceMarker } from './findGeofenceMarker'
import { createGeofenceFeature } from './createGeofenceFeature'

const nonblockingRender = createNonBlockingRenderByTime()

export const changelogAddGeofenceFeatures = async (
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.Geofence>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['geofence'],
  selection: Set<string>,
  markerIds: IterableIterator<string>,
) => {
  const features: Feature<Geometry>[] = []

  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const marker = findGeofenceMarker(markers, markerId)
    if (!marker) {
      throw new Error(
        `Trying to add Geofence feature with id: ${markerId} but no marker exist on the map`,
      )
    }

    const selected = selection.has(markerId)

    features.push(createGeofenceFeature(marker, mapStyles, selected))
  }

  // add all new features to the layer
  layer.getSource()?.addFeatures(features)

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
